import { DT } from '../../theme/designTokens';
import type { ChatMessage } from '../../types/game';
import { DesktopChatSection } from '../chat/DesktopChatSection';
import { PANEL_LABEL } from './MatchCard';
import { useTranslation } from '../../i18n/react';

/**
 * GameChatSection — the CHAT section of the game info panel, per the GAMESCENE
 * Figma: a "CHAT" label + collapse chevron, the message list (when expanded),
 * and the input row. Collapsing hides the message list; the input stays.
 *
 * Reused by desktop (right column, flexes to fill) and mobile (stacked, fixed
 * message height when expanded).
 */

interface Props {
  messages:    ChatMessage[];
  sendMessage: (body: string) => void;
  open:        boolean;
  onToggle:    () => void;
  onFocus?:    () => void;
  /** Desktop right column flexes to fill; mobile uses a fixed list height. */
  fill?:       boolean;
}

export function GameChatSection({ messages, sendMessage, open, onToggle, fill = true }: Props) {
  const { t } = useTranslation('gameplay');
  return (
    <div
      style={{
        display:       'flex',
        flexDirection: 'column',
        minHeight:     0,
        flex:          fill && open ? 1 : undefined,
      }}
    >
      <button
        onClick={onToggle}
        aria-expanded={open}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          background: 'none', border: 'none', padding: 0, cursor: 'pointer',
          marginBottom: 10, width: '100%',
        }}
      >
        <span style={PANEL_LABEL}>{t('chat.heading')}</span>
        <svg
          width="16" height="11" viewBox="0 0 16 11" fill="none" aria-hidden="true"
          style={{ transform: open ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.2s' }}
        >
          <path d="M2 9L8 3l6 6" stroke={DT.color.gold} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <div style={{ display: open && fill ? 'flex' : 'block', flexDirection: 'column', flex: open && fill ? 1 : undefined, minHeight: 0 }}>
        <DesktopChatSection messages={messages} sendMessage={sendMessage} collapsed={!open} />
      </div>
    </div>
  );
}
